import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './FacilitiesOperationsComponent.metadata.json5';
import styles from '../MedicalPractitioners.module.scss';
import ScheduleOfFacilitiesComponent from '../subcomponents/ScheduleOfFacilitiesServices/ScheduleOfFacilitiesComponent';
import SurgicalCentreComponent from '../subcomponents/SurgicalCentre/SurgicalCentreComponent';
import DiagnosticCentreComponent from '../subcomponents/DiagnosticCentre/DiagnosticCentreComponent';
import MedicalClinicComponent from '../subcomponents/MedicalClinic/MedicalClinicComponent';

function FacilitiesOperationsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('FacilitiesOperationsComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const offeringCoverablePath = 'lobData.proLine.coverables.medicalParctitionarsCoverable.facilitiesOperations.'

    const isSurgicalCenterAvailable = () => {        
        if(_.get(submissionVM.value, `${offeringCoverablePath}surgicalCentreDTO`).length > 0) {
            return true;
        }

        return false
    }

    const isHairTransplantSelected = () => {
        const surgicalCentres = _.get(submissionVM.value, `${offeringCoverablePath}surgicalCentreDTO`)
        let hairFound = false
        let count = 0;

        if(surgicalCentres.length > 0 && count === 0) {
            surgicalCentres.forEach(element => {
                if(element.sur1 === 'HaiTrans') {
                    count += 1;
                    hairFound = true;
                }
            });
        }

        return hairFound
    }

    const isFertilityClinicSelected = () => {
        const medicalClinic = _.get(submissionVM.value, `${offeringCoverablePath}medicalClinicDTO`)
        let fertilityClinicFound = false
        let count = 0;

        if(medicalClinic.length > 0 && count === 0) {
            medicalClinic.forEach(element => {
                if(element.medCli1 === 'FerCli') {
                    count += 1;
                    fertilityClinicFound = true;
                }
            });
        }

        return fertilityClinicFound
    }

    const isDiagnosticCenterAvailable = () => {
        if(_.get(submissionVM.value, `${offeringCoverablePath}diagnosticCentreDTO`).length > 0) {
            return true;
        }

        return false
    }

    const totalPercentageOfScheduleServices = () =>{
        let totalScheduleServices = 0;
        const scheduleOfFacilitiesServices = _.get(submissionVM.value, `${offeringCoverablePath}scheduleOfFacilitiesServicesDTO`)
        
        if(scheduleOfFacilitiesServices.length > 0) {
            scheduleOfFacilitiesServices.forEach(element => {
                if(!_.isUndefined(element.perOfRev2)) {
                    totalScheduleServices += element.perOfRev2;
                }
            })
        }

        _.set(modelVM.value, 'totSchOfSer28', totalScheduleServices);

        return totalScheduleServices;
    }

    const totalPercentageOfDiagnosticCentreRevenue = () =>{
        let totalDiagnosticCentreRevenue = 0;
        const scheduleOfDiagnosticCentreRevenue = _.get(submissionVM.value, `${offeringCoverablePath}diagnosticCentreDTO`)
        
        if(scheduleOfDiagnosticCentreRevenue.length > 0) {
            scheduleOfDiagnosticCentreRevenue.forEach(element => {
                if(!_.isUndefined(element.perOfRev2)) {
                    totalDiagnosticCentreRevenue += element.perOfRev2;
                }
            })
        }

        _.set(modelVM.value, 'totFacOpe42', totalDiagnosticCentreRevenue);

        return totalDiagnosticCentreRevenue;
    }

    const totalPercentageOfSurgicalCentreRevenue = () =>{
        let totalSurgicalCentreRevenue = 0;
        const scheduleOfSurgicalCentreRevenue = _.get(submissionVM.value, `${offeringCoverablePath}surgicalCentreDTO`)
        
        if(scheduleOfSurgicalCentreRevenue.length > 0) {
            scheduleOfSurgicalCentreRevenue.forEach(element => {
                if(!_.isUndefined(element.perOfRev2)) {
                    totalSurgicalCentreRevenue += element.perOfRev2;
                }
            })
        }

        _.set(modelVM.value, 'totFacOpe30', totalSurgicalCentreRevenue);

        return totalSurgicalCentreRevenue;
    }

    const totalPercentageOfMedicalCentreRevenue = () =>{
        let totalMedicalCentreRevenue = 0;
        const scheduleOfMedicalCentreRevenue = _.get(submissionVM.value, `${offeringCoverablePath}medicalClinicDTO`)
        
        if(scheduleOfMedicalCentreRevenue.length > 0) {
            scheduleOfMedicalCentreRevenue.forEach(element => {
                if(!_.isUndefined(element.perOfRev2)) {
                    totalMedicalCentreRevenue += element.perOfRev2;
                }
            })
        }

        _.set(modelVM.value, 'totFacOpe46', totalMedicalCentreRevenue);

        return totalMedicalCentreRevenue;
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        accBod25: {
            visible: !_.isUndefined(modelVM.value.isTheAppAnAccFac24) && modelVM.value.isTheAppAnAccFac24
        },
        lasYeaAccAwa26: {
            visible: !_.isUndefined(modelVM.value.isTheAppAnAccFac24) && modelVM.value.isTheAppAnAccFac24
        },
        totSchOfSer28: {
            value: totalPercentageOfScheduleServices(),
            disabled: true
        },
        totFacOpe30: {
            value: totalPercentageOfSurgicalCentreRevenue(),
        },
        totFacOpe42: {
            value: totalPercentageOfDiagnosticCentreRevenue(),
        },
        totFacOpe46: {
            value: totalPercentageOfMedicalCentreRevenue(),
        },
        surgicalCentreContainer: {
            visible: isSurgicalCenterAvailable()
        },
        hairTransplantFacilityContainer: {
            visible: isHairTransplantSelected()
        },
        diagnosticTableContainer: {
            visible: isDiagnosticCenterAvailable()
        },
        fertilityClinicContainer: {
            visible: isFertilityClinicSelected()
        },
        scheduleOfFacilitiesComponent: {
            data: modelVM.scheduleOfFacilitiesServicesDTO,
            updateWizardData,
            submissionVM,
            ScheduleOfFacilitiesComponentPath: `${pathUpdated}.scheduleOfFacilitiesServicesDTO`
        },
        surgicalCentreComponent: {
            data: modelVM.surgicalCentreDTO,
            updateWizardData,
            submissionVM,
            SurgicalCentreComponentPath: `${pathUpdated}.surgicalCentreDTO`
        },
        diagnosticCentreComponent: {
            data: modelVM.diagnosticCentreDTO,
            updateWizardData,
            submissionVM,
            DiagnosticCentreComponentPath: `${pathUpdated}.diagnosticCentreDTO`
        },
        medicalClinicComponent: {
            data: modelVM.medicalClinicDTO,
            updateWizardData,
            submissionVM,
            MedicalClinicComponentPath: `${pathUpdated}.medicalClinicDTO`
        },
        pleStaForWhoCliResPro58: {
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        doYouRecFulIndFroThe59: {
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        pleProAnnRevDerFroCli60: {
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        pleStaTheNumOfTriDur61:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        pleStaTheAntNumOfTri62:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        doVolSigAnInfConFor63:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        areDouBliStuConAndAre64:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        doTriInvFemVolOfChi65:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        doeTheAppConAnyForRes66:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        doeTheAppConAnyForRes67:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        doeTheAppConAnyForRes68:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        doeTheAppConAnyForRes69:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        doeTheAppConAnyForRes70:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        doeTheAppConAnyForRes71:{
            visible: !_.isUndefined(modelVM.value.doeTheAppParInCliTri57) && modelVM.value.doeTheAppParInCliTri57
        },
        ifYesPleConWhaTraHas87:{
            visible: !_.isUndefined(modelVM.value.doYouOrAnyOfYouEmp86) && modelVM.value.doYouOrAnyOfYouEmp86
        },
        estNumOfScaAndOrIma43: {
            defaultValue: 0,
            required: isDiagnosticCenterAvailable()
        },
        estNumOfObsUltFetSca44: {
            defaultValue: 0,
            required: isDiagnosticCenterAvailable()
        },
        pleProPer100BreOfThe48: {
            required: isFertilityClinicSelected()
        },
        pleProPer100BreOfThe49: {
            required: isFertilityClinicSelected()
        },
        pleProPer100BreOfThe50: {
            required: isFertilityClinicSelected()
        },
        pleProPer100BreOfThe51: {
            required: isFertilityClinicSelected()
        },
        pleProPer100BreOfThe52: {
            required: isFertilityClinicSelected()
        },
        pleProPer100BreOfThe53: {
            required: isFertilityClinicSelected()
        },
        areCouSerAvaToPat54: {
            required: isFertilityClinicSelected()
        },
        isAllDonSemScrCryAnd55: {
            required: isFertilityClinicSelected()
        },
        doeTheAppHavABloBan31: {
            required: isSurgicalCenterAvailable()
        },
        doeTheAppUndAnyTesOf32: {
            required: isSurgicalCenterAvailable()
        },
        is100OfTheBloOrBlo33: {
            required: isSurgicalCenterAvailable()
        },
        pleStaTheAveNumOfUni34: {
            required: isSurgicalCenterAvailable()
        },
        pleProDetOnBloStoFac35: {
            required: isSurgicalCenterAvailable()
        },
        ifAHaiTraFacPlePro37: {
            required: isHairTransplantSelected()
        },
        ifAHaiTraFacBpl38: {
            required: isHairTransplantSelected()
        },
        ifAHaiTraFacBpl39: {
            required: isHairTransplantSelected()
        },
        ifAHaiTraFacBpl40: {
            required: isHairTransplantSelected()
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            scheduleOfFacilitiesComponent: ScheduleOfFacilitiesComponent,
            surgicalCentreComponent: SurgicalCentreComponent,
            diagnosticCentreComponent: DiagnosticCentreComponent,
            medicalClinicComponent: MedicalClinicComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

FacilitiesOperationsComponent.propTypes = wizardProps;
export default withRouter(FacilitiesOperationsComponent);
